import {
  put, select, all, call,
} from 'lib/redux';
import { getOrderPreferencesSaga, getUserProductsSaga } from 'features/userData/UserData.saga';
import {
  SAVE_ORDER_PREFERENCES_LOADING, SAVE_ORDER_PREFERENCES_SUCCESS, SAVE_ORDER_PREFERENCES_ERROR,
  UPDATE_ORDER_PREFERENCES_INPUT_FIELD_PROPERTY,
} from 'constants/ActionTypes';
import saveOrderPreferencesService from 'services/saveOrderPreferences.service';
import { scrollToTop, isObjectEmpty, trackUserEvent } from 'utils/app.utils';
import { USER_EVENTS } from 'constants/AppConstants';
import { validateOrderPreferenceInputs } from './OrderPreferences.utils';

export function* updateInputFieldValueSaga({ propertyName, key, value }) {
  const orderPreferences = yield select(({ userData }) => userData.orderPreferences);
  const { inputFieldValues, saveLoading } = yield select(({ orderPreference }) => orderPreference);
  if (!saveLoading) {
    yield put({
      type: UPDATE_ORDER_PREFERENCES_INPUT_FIELD_PROPERTY,
      propertyName,
      propertyValues: {
        ...orderPreferences[propertyName],
        ...inputFieldValues[propertyName],
        [key]: value,
      },
    });
  }
}

export function* saveOrderPreferencesSaga() {
  try {
    trackUserEvent(USER_EVENTS.SAVE_ORDER_PREFERENCES);
    yield put({ type: SAVE_ORDER_PREFERENCES_LOADING });

    const { inputFieldValues } = yield select(({ orderPreference }) => orderPreference);

    const orderPreferenceInputErrors = validateOrderPreferenceInputs(inputFieldValues);

    if (!isObjectEmpty(orderPreferenceInputErrors)) {
      yield put({ type: SAVE_ORDER_PREFERENCES_ERROR, errors: orderPreferenceInputErrors });
      scrollToTop();
      return;
    }

    const response = yield saveOrderPreferencesService(inputFieldValues);

    if (!response.ok) {
      const error = new Error(response.json.errorDescription);
      error.errorCode = response.json.errorCode;
      throw error;
    }
    yield all([
      call(getOrderPreferencesSaga, { isUpdated: true }),
      call(getUserProductsSaga, { isUpdated: true }),
    ]);

    yield put({ type: SAVE_ORDER_PREFERENCES_SUCCESS });
    scrollToTop();
  } catch (error) {
    yield put({ type: SAVE_ORDER_PREFERENCES_ERROR });
    scrollToTop();
  }
}
